<template>
  <div class="scenes__items">
    <Loading v-if="isLoading" />
    <SceneBoxes v-else :scenes="scenes" />
  </div>
</template>
<script>
import SceneBoxes from '../../organism/scenes/SceneBoxes'
import Loading from '../../atoms/loadings/Loading'
import axios from 'axios'
export default {
  components: { SceneBoxes, Loading },
  data() {
    return {
      scenes: [],
      isLoading: false
    }
  },
  mounted() {
    this.getScenes()
  },
  methods: {
    async getScenes() {
      this.isLoading = true
      try {
        const res = await axios.get('/api/v1/pickup/scenes')
        this.scenes = res.data.data
          .map(scene => scene.attributes)
          .map(scene => ({
            id: scene.id,
            name: scene.name,
            description: scene.description,
            imageUrl: scene.list_image_url
          }))
      } catch (error) {
        this.showableErrorFeedback = true
        this.errorMessage =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'システムエラーが発生しました。しばらく経ってから再度アクセスしてください'
      }
      this.isLoading = false
    },
    onClickLink() {
      window.history.back()
    }
  }
}
</script>
